
import  {
    faCaretUp,
    faExpand,
    faCompress,
    faMagnifyingGlassPlus,
    faMagnifyingGlassMinus
} from "@awesome.me/kit-5f107d6f8b/icons/sharp/regular";

const sharpRegular = {
    faCaretUp,
    faExpand,
    faCompress,
    faMagnifyingGlassPlus,
    faMagnifyingGlassMinus
};

export {
    sharpRegular,
};
